module.exports = __webpack_public_path__ + "static/media/bff11.2a1147fa.png";